/* Insertar un texto · Imprimirlo
 *
 * Uno o dos pedidos de cada diez no traen logo: traen una frase. El nombre de
 * la peña, la fecha de la despedida, "Equipo de obra" y poco más.
 *
 * LA IDEA: un texto NO es una cosa nueva en el configurador, es otra forma de
 * fabricar un ARTE. Se escribe, se dibuja en un canvas a 300 ppp con la medida
 * exacta de la zona, se convierte en PNG y a partir de ahí viaja como un
 * archivo cualquiera: la vista de la prenda, el mockup del pedido, el precio,
 * el aviso de camuflaje y el fichero que Xavi manda a la máquina son los que ya
 * estaban probados. Ni una rama nueva en el carrito.
 *
 * POR QUÉ SE RASTERIZA AQUÍ Y NO EN EL TALLER: porque así lo que el cliente ve
 * es exactamente lo que se imprime. Si el taller volviera a escribir el texto,
 * cualquier diferencia de fuente o de espaciado sería una discusión. El pedido
 * lleva IGUALMENTE el texto literal, la fuente y el color, para poder
 * rehacerlo si hace falta.
 *
 * LAS FUENTES SE CARGAN Y SE ESPERAN. Empezaron siendo familias de sistema por
 * miedo a que una web no estuviera lista cuando se dibuja el PNG y se imprimiera
 * la de repuesto sin que nadie se enterase. Pero eso se arregla esperándolas:
 * `cargar()` mete el <link> y no devuelve hasta que `document.fonts` dice que
 * están. Así se pueden ofrecer tipografías de verdad —de las de camiseta— y
 * además un Mac y un PC dibujan lo mismo, que con las de sistema no pasaba.
 *
 * Se cargan LA PRIMERA VEZ QUE ALGUIEN ABRE EL FORMULARIO, no al entrar en la
 * ficha: nueve de cada diez clientes suben un logo y no tienen por qué pagar la
 * descarga. Y si la descarga falla o tarda más de 4 s, se dibuja con la de
 * repuesto antes que dejar al cliente mirando un hueco.
 *
 * Todas son de licencia abierta (SIL OFL / Apache), así que se pueden imprimir
 * y vender sin pagar a nadie.
 *
 * MISMO TEXTO EN TODAS LAS PRENDAS. Los dorsales y los nombres uno a uno
 * (despedidas: "novia", "dama 1") no van aquí: eso es otro producto, con su
 * propia lista de nombres, y mezclarlo obligaría a cambiar el carrito entero.
 */
(function () {
  'use strict';

  var PPP = 300;               // los mismos que usa el taller
  var NOMINAL = 200;           // tamaño de medir, antes de escalar
  var INTERLINEA = 1.08;

  /* Las fuentes que se ofrecen. Se pueden cambiar desde la configuración de la
     ficha (texto.fuentes) sin tocar este fichero.

       web    · lo que se le pide a Google Fonts. Si falta, es una familia de
                sistema y no se descarga nada.
       css    · la pila completa, CON repuesto: si la descarga falla, el texto
                se dibuja igual y se parece lo que se pueda.
       peso   · el grosor que se descarga y con el que se dibuja.

     El nombre que ve el cliente es descriptivo y no el de la tipografía: a
     nadie que quiere una camiseta le dice nada "Bebas Neue". */
  var FUENTES = [
    { id: 'gruesa', nombre: 'Gruesa', web: 'Anton', peso: '400',
      css: '"Anton", Impact, Haettenschweiler, sans-serif' },
    { id: 'deportiva', nombre: 'Deportiva', web: 'Bebas+Neue', peso: '400',
      css: '"Bebas Neue", Impact, "Arial Narrow", sans-serif' },
    { id: 'redonda', nombre: 'Redonda', web: 'Montserrat:wght@800', peso: '800',
      css: '"Montserrat", "Helvetica Neue", Arial, sans-serif' },
    { id: 'college', nombre: 'College', web: 'Alfa+Slab+One', peso: '400',
      css: '"Alfa Slab One", Rockwell, Georgia, serif' },
    { id: 'clasica', nombre: 'Clásica', web: 'Playfair+Display:wght@700', peso: '700',
      css: '"Playfair Display", Georgia, "Times New Roman", serif' },
    { id: 'estarcido', nombre: 'Estarcido', web: 'Black+Ops+One', peso: '400',
      css: '"Black Ops One", Impact, sans-serif' },
    { id: 'rotulador', nombre: 'Rotulador', web: 'Permanent+Marker', peso: '400',
      css: '"Permanent Marker", "Comic Sans MS", cursive' },
    { id: 'manuscrita', nombre: 'Manuscrita', web: 'Caveat:wght@700', peso: '700',
      css: '"Caveat", "Segoe Script", "Bradley Hand", cursive' },
    { id: 'caligrafia', nombre: 'Caligrafía', web: 'Great+Vibes', peso: '400',
      css: '"Great Vibes", "Apple Chancery", cursive' },
    { id: 'maquina', nombre: 'Máquina', web: 'Special+Elite', peso: '400',
      css: '"Special Elite", "Courier New", monospace' }
  ];

  function fuenteDe(id, lista) {
    var f = (lista || FUENTES).filter(function (x) { return x.id === id; })[0];
    return f || (lista || FUENTES)[0] || FUENTES[0];
  }

  function css(f, px) { return (f.peso || '400') + ' ' + Math.round(px) + 'px ' + f.css; }

  // "Playfair+Display:wght@700" → Playfair Display
  function familia(f) {
    return String(f.web || '').split(':')[0].replace(/\+/g, ' ');
  }

  /* Carga las tipografías y no devuelve hasta que se pueden dibujar. Una sola
     vez por visita: la promesa se guarda y se reparte. */
  var cargando = null;

  function cargar(lista) {
    if (cargando) return cargando;
    lista = (lista && lista.length) ? lista : FUENTES;
    var web = lista.filter(function (f) { return !!f.web; });

    if (web.length && !document.querySelector('link[data-texto-fuentes]')) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = 'https://fonts.googleapis.com/css2?' +
        web.map(function (f) { return 'family=' + f.web; }).join('&') + '&display=swap';
      l.setAttribute('data-texto-fuentes', '');
      document.head.appendChild(l);
    }

    var espera = [];
    if (window.document && document.fonts && document.fonts.load) {
      web.forEach(function (f) {
        try {
          espera.push(document.fonts.load((f.peso || '400') + ' 100px "' + familia(f) + '"'));
        } catch (e) { /* una que no cargue no puede tumbar a las demás */ }
      });
    }
    /* Lo que primero ocurra: que estén todas, o que pasen 4 segundos. Un texto
       dibujado con la de repuesto es peor que el bueno, pero infinitamente
       mejor que una ficha que se queda colgada. */
    cargando = Promise.race([
      Promise.all(espera).catch(function () { return null; }),
      new Promise(function (ok) { setTimeout(ok, 4000); })
    ]);
    return cargando;
  }

  /* Las líneas útiles: sin vacías, sin espacios de sobra y con un tope. Tres
     líneas ya es un cartel; más no cabe en una espalda sin quedar ilegible. */
  function lineas(texto, tope) {
    return String(texto || '').split('\n')
      .map(function (l) { return l.replace(/\s+/g, ' ').trim(); })
      .filter(function (l) { return !!l; })
      .slice(0, tope || 3);
  }

  /* La caja de tinta de verdad, no la de la fuente. measureText da el alto de
     los trazos que se van a dibujar (actualBoundingBox), así que "HOLA" no
     arrastra el hueco de las letras con cola y el texto llena la zona. */
  function medir(ctx, ls, f, px, esp, g) {
    ctx.font = css(f, px);
    if ('letterSpacing' in ctx) ctx.letterSpacing = esp ? (esp * px).toFixed(2) + 'px' : '0px';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'alphabetic';
    var w = 0, subes = [], bajas = [];
    ls.forEach(function (l) {
      var m = ctx.measureText(l);
      w = Math.max(w, m.width);
      /* Navegadores viejos no dan actualBoundingBox; se cae a una estimación
         del tamaño de la fuente antes que romperse. */
      subes.push(m.actualBoundingBoxAscent != null ? m.actualBoundingBoxAscent : px * 0.75);
      bajas.push(m.actualBoundingBoxDescent != null ? m.actualBoundingBoxDescent : px * 0.22);
    });
    var avance = px * INTERLINEA;
    var h = subes[0] + avance * (ls.length - 1) + bajas[bajas.length - 1];
    /* grosor extra (g = fracción del cuerpo): el trazo engorda la letra por todos los lados */
    if (g) { var gp = g * px; w += gp; h += gp; subes = subes.map(function (v) { return v + gp / 2; }); bajas = bajas.map(function (v) { return v + gp / 2; }); }
    return { w: w, h: h, subes: subes, bajas: bajas, avance: avance };
  }

  /* Dibuja el texto llenando la caja que se le pida, en píxeles. Devuelve el
     canvas recortado a la tinta, con un margen pequeño: así la proporción del
     PNG es la del texto y quien decide la medida final sigue siendo
     Colocacion.medida, igual que con un logo. */
  function pinta(texto, opciones) {
    var o = opciones || {};
    var ls = lineas(texto, o.maxLineas);
    if (o.mayus) ls = ls.map(function (l) { return l.toUpperCase(); });
    if (!ls.length) return null;
    var esp = o.espaciado || 0;
    var f = o.fuente && o.fuente.css ? o.fuente : fuenteDe(o.fuente, o.fuentes);
    var ppp = o.ppp || PPP;
    var caja = o.cajaCm || [20, 20];
    var anchoPx = caja[0] * ppp / 2.54, altoPx = caja[1] * ppp / 2.54;

    var med = document.createElement('canvas').getContext('2d');
    var gr = o.grosor || 0, m0 = medir(med, ls, f, NOMINAL, esp, gr);
    if (!m0.w || !m0.h) return null;
    var k = Math.min(anchoPx / m0.w, altoPx / m0.h);
    var tam = Math.max(8, NOMINAL * k);

    // se vuelve a medir al tamaño final: el escalado de fuentes no es exacto
    var m = medir(med, ls, f, tam, esp, gr);
    var margen = Math.max(2, Math.round(tam * 0.04));
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.ceil(m.w) + margen * 2);
    c.height = Math.max(1, Math.ceil(m.h) + margen * 2);
    var x = c.getContext('2d');
    x.font = css(f, tam);
    if ('letterSpacing' in x) x.letterSpacing = esp ? (esp * tam).toFixed(2) + 'px' : '0px';
    x.textAlign = 'center';
    x.textBaseline = 'alphabetic';
    x.fillStyle = o.color || '#000000';
    if (gr) { x.strokeStyle = o.color || '#000000'; x.lineWidth = gr * tam; x.lineJoin = 'round'; }
    var y = margen + m.subes[0];
    for (var i = 0; i < ls.length; i++) {
      var xx = c.width / 2 + (esp ? esp * tam / 2 : 0);
      if (gr) x.strokeText(ls[i], xx, y);
      x.fillText(ls[i], xx, y);
      y += m.avance;
    }
    return { lienzo: c, tam: tam, lineas: ls };
  }

  // un nombre de fichero que Xavi pueda leer en su carpeta sin abrirlo
  function nombre(ls) {
    var s = ls.join(' ').toLowerCase();
    if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
    s = s.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
    return 'texto-' + (s || 'sin-titulo') + '.png';
  }

  /* El dato que entiende el resto del configurador. Se pasa por Archivo.leer a
     propósito, en vez de montarlo a mano: así el texto se mide, se recorta y se
     analiza con el MISMO código que un archivo del cliente, y lo que se añada
     ahí en el futuro vale también para los textos. */
  async function dato(texto, opciones) {
    if (!window.Archivo || !window.ImgArreglo) return null;
    var o = opciones || {};
    /* Antes de rasterizar, la fuente TIENE que estar. Aquí no vale el repuesto:
       esto ya no es una previa, es el fichero que se va a imprimir. */
    await cargar(o.fuentes);
    var r = pinta(texto, o);
    if (!r) return null;
    var f = o.fuente && o.fuente.css ? o.fuente : fuenteDe(o.fuente, o.fuentes);
    var file = await ImgArreglo.aFichero(r.lienzo, nombre(r.lineas));
    var d = await Archivo.leer(file);
    /* Lo que hace falta para poder EDITARLO después y para que el taller pueda
       rehacerlo: el texto tal cual, la fuente y el color. */
    d.texto = { texto: r.lineas.join('\n'), fuente: f.id, nombreFuente: f.nombre, color: o.color || '#000000' };
    return d;
  }

  // cómo se lee un texto en el pedido de Xavi
  function pedido(t) {
    if (!t) return '';
    return '«' + t.texto.replace(/\n/g, ' / ') + '» · ' + (t.nombreFuente || t.fuente) + ' · ' + t.color;
  }

  window.Texto = {
    FUENTES: FUENTES, fuenteDe: fuenteDe, lineas: lineas, familia: familia,
    cargar: cargar, pinta: pinta, dato: dato, pedido: pedido, css: css
  };
})();